import React from "react";
import { observer } from "mobx-react";
import { TenantStatusUpdateStore } from "../../store";
import { TenantStatusUpdateForm } from "./TenantStatusUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type TenantStatusUpdateProps = {
  tenantStatusUpdateStore: TenantStatusUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantStatusUpdate: React.FC<TenantStatusUpdateProps> = observer(
  ({ tenantStatusUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={tenantStatusUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={tenantStatusUpdateStore.savedButOutdated}
          onReload={() => tenantStatusUpdateStore.reloadTenantStatus()}
          reloadDisabled={tenantStatusUpdateStore.isProcessing}
        />
        <TenantStatusUpdateForm
          tenantStatusUpdateStore={tenantStatusUpdateStore}
          nameError={tenantStatusUpdateStore.errors.name?.message}
          onNameChange={(value: string) => {
            tenantStatusUpdateStore.setNameValue(value);
          }}
          name={tenantStatusUpdateStore.entityValues.name}
          description_esError={
            tenantStatusUpdateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            tenantStatusUpdateStore.setDescription_esValue(value);
          }}
          description_es={tenantStatusUpdateStore.entityValues.description_es}
          description_enError={
            tenantStatusUpdateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            tenantStatusUpdateStore.setDescription_enValue(value);
          }}
          description_en={tenantStatusUpdateStore.entityValues.description_en}
          description_ptError={
            tenantStatusUpdateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            tenantStatusUpdateStore.setDescription_ptValue(value);
          }}
          description_pt={tenantStatusUpdateStore.entityValues.description_pt}
          blocksAccessError={
            tenantStatusUpdateStore.errors.blocksAccess?.message
          }
          onBlocksAccessChange={(value: boolean) => {
            tenantStatusUpdateStore.setBlocksAccessValue(value);
          }}
          blocksAccess={tenantStatusUpdateStore.entityValues.blocksAccess}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={tenantStatusUpdateStore.saveDisabled}
          onSave={() => tenantStatusUpdateStore.saveTenantStatus()}
          onCancel={() => tenantStatusUpdateStore.cancelTenantStatus()}
        />
        <ErrorDialog
          open={tenantStatusUpdateStore.errorDialogOpened}
          title={tenantStatusUpdateStore.errorTitle}
          description={tenantStatusUpdateStore.errorDescription}
          onClose={() => tenantStatusUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={tenantStatusUpdateStore.confirmDialogOpened}
          title={tenantStatusUpdateStore.confirmDialogTitle}
          description={tenantStatusUpdateStore.confirmDialogDescription}
          onConfirm={() => tenantStatusUpdateStore.executeConfirmedAction()}
          onCancel={() => tenantStatusUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
